"use client";

import Link from "next/link";
import Sites from "src/constants/Sites";
import { useAppContext } from "./Provider";

export function RenderCategories() {
  const { data, siteId } = useAppContext();
  const categories = data?.Categories;

  if (siteId !== Sites.OPENROADMEDIA && categories) {
    return (
      <div className="listContainer">
        <p className="boldHead">Search via Category : </p>
        <ul className="categoryList" style={{ paddingLeft: "0px", listStyleType: "none" }}>
          {categories.map((link, index) => {
            return (
              <li className="" key={"category_404_" + index}>
                <Link href={`/category/${link?.name?.toString().toLowerCase()}`}>
                  {link.name.toString().replace(/-/g, " ")}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return <></>;
}
